// TODO: conversion for other units & currency
// Ref: https://stackoverflow.com/a/11832950/8102492
export const getReadableAmount = (value: PayScale): string => {
  if (value.amount === null || value.currency === null) return `N/A`

  switch (value.currency) {
    case 1: {
      // from paise to rupee
      const roundedAmount = Math.round(value.amount + Number.EPSILON) / 100
      return `₹ ${Intl.NumberFormat('en-IN').format(roundedAmount)}`
    }
    case 2: {
      // from paise to rupee
      const roundedAmount = Math.round(value.amount + Number.EPSILON)
      return `₹ ${Intl.NumberFormat('en-IN').format(roundedAmount)}`
    }
    case 4: {
      // from cents to dollar
      const roundedAmount = Math.round(value.amount + Number.EPSILON) / 100
      return `$ ${Intl.NumberFormat('USD').format(roundedAmount)}`
    }
    case 5: {
      // from microcents to dollar
      const roundedAmount = Math.round(value.amount + Number.EPSILON) / 10000
      return `$ ${roundedAmount}`
    }
    default:
      return 'not handled'
  }
}

export const convertCurrencyToRupee = (value: PayScale): number => {
  if (value.amount === null || value.currency === null) {
    throw new Error('Currency or amount is null')
  }

  switch (value.currency) {
    case 1:
    case 4: {
      return Math.round(value.amount + Number.EPSILON) / 100
    }
    default:
      throw new Error('currency not handled')
  }
}

export const getCurrencyName = (currencyType: number): string => {
  switch (currencyType) {
    case 1:
    case 2: {
      return 'INR'
    }
    case 4:
    case 5: {
      return 'USD'
    }
    default:
      throw new Error('currency not handled')
  }
}

export const getCurrencySign = (currencyType: number): string => {
  switch (currencyType) {
    case 1:
    case 2: {
      return '₹'
    }
    case 4:
    case 5: {
      return '$ '
    }
    default:
      throw new Error('currency not handled')
  }
}

const US_CURRENCY = 5
const US_MICROCENTS = 10000
const PAISE = 100

export const currencyMultiplier = (currencyCode: number) => {
  if (currencyCode === US_CURRENCY) {
    return US_MICROCENTS
  }
  return PAISE
}

export interface Bill {
  currency: number
  bill_number: string
  payment_date: string | number | Date
  status: string
  description: string
  assignment_count: number
  paid: string
  sub_total: string
  total: string
  id: string
  tds: number
  igst: number
  sgst: number
  cgst: number
  error?: Error | null
  currency_symbol: string
}

export interface Error {
  code: string
  explanation: string
  next_step: string
  retryable: boolean
  vendor: string
  internal: boolean
}

export const extractGSTAndTDS = (bill: Bill) => {
  const currency = bill.currency || 1
  const multiplier = currencyMultiplier(currency)

  const tdsValue =
    Number(bill.tds) > 0
      ? Math.ceil(Number(bill.sub_total) * (Number(bill.tds) / 100))
      : 0
  const igstValue =
    Number(bill.igst) > 0
      ? Number(bill.sub_total) * (Number(bill.igst) / 100)
      : 0
  const sgstValue =
    Number(bill.sgst) > 0
      ? Number(bill.sub_total) * (Number(bill.sgst) / 100)
      : 0
  const cgstValue =
    Number(bill.cgst) > 0
      ? Number(bill.sub_total) * (Number(bill.cgst) / 100)
      : 0

  const tdsFinalValue = getReadableAmount({
    amount: Number(tdsValue) * multiplier,
    currency
  })

  const igstFinalValue = getReadableAmount({
    amount: igstValue * multiplier,
    currency
  })

  const sgstFinalValue = getReadableAmount({
    amount: Number(sgstValue) * multiplier,
    currency
  })
  const cgstFinalValue = getReadableAmount({
    amount: Number(cgstValue) * multiplier,
    currency
  })
  return { tdsFinalValue, igstFinalValue, sgstFinalValue, cgstFinalValue }
}

export const getReadableCurrency = ({
  amount,
  currency
}: {
  amount: number | null
  currency: string | null
}) => {
  if (amount === null || currency === null) return `N/A`

  switch (currency) {
    case 'INR': {
      // from paise to rupee
      const formattedAmount = amount / 100
      return `₹${formattedAmount.toLocaleString('en-IN', {
        maximumFractionDigits: 4
      })}`
    }
    case 'USD': {
      // from cents to dollar
      const formattedAmount = amount / 100
      return `$${formattedAmount.toLocaleString('USD', {
        maximumFractionDigits: 4
      })}`
    }

    default:
      return '-'
  }
}
